import { Component, Vue } from "vue-property-decorator";
import { getAssignSeller, getPoint } from "@/api/seller";
import { getQueryString } from "@/libs/tools";

@Component
export default class AssignSeller extends Vue {
    private role: string = "SELLER";
    private qrUrl: string = "";
    private wxCode: string = "";
    private get productId(): number {
        return +this.$route.params.productId;
    }
    private source: string | boolean = "";
    private copyTips: boolean = false;
    mounted() {
        this.source = getQueryString("source") ? getQueryString("source") : "";
        getAssignSeller(this.productId, this.role, this.source).then(res => {
            this.qrUrl = res.data.qrUrl;
            this.wxCode = res.data.wxCode;
        });
        this.Point(133);
    }
    getSellerCode() {
        this.Point(134);
        this.$copyText(this.wxCode).then(() => {
            this.copyTips = true;
        });
    }
    Point(key) {
        let pointParams = {
            source: this.source,
            productId: this.productId,
            pageType: 1
        };
        pointParams["pageKey"] = key;
        getPoint(pointParams).then(res => {});
    }
    handleCloseTips() {
        this.copyTips = false;
    }
}
